import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import DropdownToggle from '../scripts/dropdown/DropdownToggle';
import DropdownMenu from '../scripts/dropdown/DropdownMenu';
import DropdownItem from '../scripts/dropdown/DropdownItem';
import Dropdown from '../scripts/dropdown';
import { checkPermission, notifyWithIcon } from '../services/utilities';
import {
	PREVIOUS_PATH,
	TOKEN_COOKIE,
	TOKEN_EXPIRATION,
} from '../services/constants';
import { request } from '../services/http';
import { LOGOUT_API } from '../services/api';
import { signOut } from '../redux/slices/account';
import LocalStorage from '../services/storage';
import { disconnectSocket } from '../services/socket';
import { useNotification } from '../hooks/notification';

const storage = new LocalStorage();

const ProfileDropdown = () => {
	const [isProfileDropdown, setIsProfileDropdown] = useState(false);

	const permissions = useSelector(state => state.account.permissions);
	const user = useSelector(state => state.account.user);

	const dispatch = useDispatch();
	const notify = useNotification();

	const toggleProfileDropdown = () => {
		setIsProfileDropdown(!isProfileDropdown);
	};

	const doLogout = async () => {
		try {
			const config = { method: 'POST', body: {} };
			const rs = await request(LOGOUT_API, config);
			storage.removeItem(TOKEN_COOKIE);
			storage.removeItem(TOKEN_EXPIRATION);
			storage.removeItem(PREVIOUS_PATH);
			disconnectSocket();
			dispatch(signOut());
			notifyWithIcon(notify, 'success', rs.message);
		} catch (e) {
			notifyWithIcon(notify, 'error', e.message);
		}
	};

	return (
		<Dropdown
			isOpen={isProfileDropdown}
			toggle={toggleProfileDropdown}
			className="ms-sm-3 header-item topbar-user"
		>
			<DropdownToggle tag="button" type="button" className="btn">
				<span className="d-flex align-items-center">
					<img
						className="rounded-circle header-profile-user"
						src={user?.profile?.avatar}
						alt="Header Avatar"
					/>
					<span className="text-start ms-xl-2">
						<span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text text-capitalize">
							{user?.profile?.fullname || ''}
						</span>
						<span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
							{user?.roles?.map(r => r.description).join(', ') || ''}
						</span>
					</span>
				</span>
			</DropdownToggle>
			<DropdownMenu className="dropdown-menu-end">
				<h6 className="dropdown-header">
					Welcome {user?.profile?.firstname || ''}!
				</h6>
				<DropdownItem className="p-0" tag="div">
					<Link to={`/profile/${user?.id}`} className="dropdown-item">
						<i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
						<span className="align-middle">Profile</span>
					</Link>
				</DropdownItem>
				<div className="dropdown-divider"></div>
				{(checkPermission(permissions, 'can-see-store-settings') ||
					checkPermission(permissions, 'can-see-store-information') ||
					checkPermission(permissions, 'can-see-general-information') ||
					checkPermission(permissions, 'can-see-shipping-zones') ||
					checkPermission(permissions, 'can-see-roles') ||
					checkPermission(permissions, 'can-see-permissions') ||
					checkPermission(permissions, 'can-see-brands') ||
					checkPermission(permissions, 'can-see-attributes') ||
					checkPermission(permissions, 'can-see-security') ||
					checkPermission(permissions, 'can-see-payment-setup') ||
					checkPermission(permissions, 'can-see-mailer')) && (
					<DropdownItem className="p-0">
						<Link to="/settings" className="dropdown-item">
							<i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{' '}
							<span className="align-middle">Settings</span>
						</Link>
					</DropdownItem>
				)}
				<DropdownItem className="p-0" tag="div">
					<a
						onClick={() => doLogout()}
						className="dropdown-item cursor-pointer"
					>
						<i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{' '}
						<span className="align-middle" data-key="t-logout">
							Logout
						</span>
					</a>
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	);
};

export default ProfileDropdown;
